define('plugin/client-login/view/ClientLoginStepView',['require','lib/view/FormView','Config','lib/Utils','plugin/client-login/view/ClientProfileFormBehavior','lib/WindowMessageListener','lib/view/mixin/IntlPhone'],function (require) {

    var FormView = require('lib/view/FormView');
    var Config = require('Config');
    var Utils = require('lib/Utils');
    var ClientProfileFormBehavior = require('plugin/client-login/view/ClientProfileFormBehavior');
    var WindowMessageListener = require('lib/WindowMessageListener');

    var IntlPhone = require('lib/view/mixin/IntlPhone');
    /**
     * Client login view
     *
     * @class ClientLoginStepView
     */
    return FormView.extend({

        template: '#client_login_step',
        ui: {
            'sign_in_data': '#sb_sign_in_form :input',
            'sign_up_data': '#sb_sign_up_form :input',
            'sign_in_btn': '#sb_sign_in_btn',
            'sign_up_btn': '#sb_sign_up_btn',
            'phoneInput' : ':input[name=phone]',
            'builtInFields': '.sb-built-in-fields'
        },
        triggers: {
            'click @ui.sign_in_btn': 'signIn',
            'click @ui.sign_up_btn': 'signUp'
        },
        events: {
            'keyup @ui.sign_in_data': '_onSignInInputKeyUp',
            'keyup @ui.sign_up_data': '_onSignUpInputKeyUp'
        },
        message: null,
        currentTab: 'sign_in',
        regions: {
            'terms': {
                'el': '#sb_terms_and_conditions',
                'allowMissingEl': true
            }
        },

        behaviors: function () {
            return {
                ClientProfileFormBehavior: {
                    behaviorClass: ClientProfileFormBehavior,
                    model: this.getOption('clientModel')
                }
            };
        },

        initialize: function () {
            this.listenTo(this.getOption('clientModel'), 'sync', this.checkIfClientLoggedIn);

            this.listenTo(this.getOption('clientModel'), 'invalid', this.renderSignUp);
            this.listenTo(this.getOption('signInModel'), 'invalid', this.renderSignIn);
            this.listenTo(this.getOption('termsModel'), 'invalid', this.renderSignUp);

            this.listenTo(this.getOption('clientModel'), 'change', this.render);

            this.message = this.getOption('message');

            this.initOpenIdAuth();

        },

        /**
         * On render add custom views to regions
         */
        onRender: function () {
            var config = Config.getInstance();
            IntlPhone.showIntlPhone(this.ui.phoneInput, {
                //required : false,
                numberDisplayFormat: 'NATIONAL',
                countryPrefix: config.getOption('country_prefix'),
                countryPrefixId: config.getOption('country_prefix_id'),
                allowedPrefix: config.getOption('country_prefix_is_changeable')?null:config.getOption('country_prefix'),
            });
            
            Backbone.Wreqr.radio.vent.trigger('page', 'render', {
                'page': 'client_login',
                'view': this,
                'client_model': this.getOption('clientModel')
            });
        },
        /**
         * Listen to messages from open id login window and fetch/update client data
         */
        initOpenIdAuth: function () {
            var listener = new WindowMessageListener();
            this.listenTo(listener, 'message', _.bind(this._handleWindowMessage, this));
        },

        /**
         * Handle open id login message
         *
         * @private
         */
        _handleWindowMessage: function (data) {
            if (data.open_id_message && !data.client) {
                this.message = 'open_id';
                if (!this.isDestroyed) {
                    this.render();
                }
            }
        },

        showTermsAndConditions: function (view) {
            this.terms.show(view);
        },

        renderSignUp: function () {
            this.currentTab = 'sign_up';
            this.render();
        },

        renderSignIn: function () {
            this.message = null;
            this.currentTab = 'sign_in';
            this.render();
        },

        checkIfClientLoggedIn: function () {
            if (this.getOption('clientModel').get('is_logged_in')) {
                this.triggerMethod('clientLogged');
            } else {
                this.triggerMethod('clientLoggedOut');
            }
        },

        getDataToSignIn: function () {
            return this._getData(this.ui.sign_in_data);
        },

        getDataToSignUp: function () {
            var data = this._getData(this.ui.sign_up_data);
            data.phone = Utils.getClientPhoneValue(
                data.phone
            );

            return data;
        },


        serializeData: function () {
            var signUpData = this.getOption('clientModel').toJSON();
/*            var phoneData = Utils.getClientPhoneData(signUpData.phone);
            _.extend(signUpData, phoneData, {
                'phone': phoneData.client_phone
            });*/

            _.extend(signUpData, {
                'phone': Utils.getClientPhoneValue(
                    signUpData.phone
                )
            });

            var message = null;
            switch (this.message) {
                case 'open_id':
                    if (signUpData.user_id) {
                        message = 'open_id_sign_up_info';
                        this.currentTab = 'sign_up';
                    }
                    break;
            }

            return _.extend({
                'allow_registration': Config.getInstance().getBooleanOption('client_login_allow_registration'),
                'allow_address': Config.getInstance().getBooleanOption('client_login_allow_address'),
                'sign_in_data': this.getOption('signInModel').toJSON(),
                'sign_up_data': signUpData,
                'sign_in_errors': this.getOption('signInModel').validationError,
                'sign_up_errors': this.getOption('clientModel').validationError,
                'info_message': message,
                'current_tab': this.currentTab
            }, this.getOption('externalData'));
        },

        onDomRefresh: function () {
            if (this.message) {
                Backbone.Wreqr.radio.vent.trigger('status_message', 'shown', {
                    'type': 'client_login_message'
                });
            } else {
                Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                    'page': 'client_login'
                });
            }
        },
        
        _onSignInInputKeyUp: function (event) {
            if (event.keyCode === this.KEY_ENTER && !event.shiftKey) {
                this.ui.sign_in_btn.trigger('click');
            }
        },
        
        _onSignUpInputKeyUp: function (event) {
            if (event.keyCode === this.KEY_ENTER && !event.shiftKey) {
                this.ui.sign_up_btn.trigger('click');
            }
        },
        
        hideBuiltInFields: function () {
            this.ui.builtInFields.hide();
        }

    });

});
